<div class="row {{ marginBottom ? 'mb-3' : '' }}">
  <label
    *ngIf="label"
    class="{{ noCols ? 'col-lg-12' : 'col-lg-4' }} col-form-label {{
      alignRight ? 'text-lg-end pe-2' : ''
    }}"
    >{{ label }}{{ required ? " *" : "" }}</label
  >
  <div
    class="{{ label && !noCols ? 'col-lg-8' : 'col-lg-12' }} {{ alignVertical ? 'my-auto' : '' }} {{
      contentPadding ? 'py-2' : ''
    }}"
  >
    <ng-content></ng-content>
  </div>
</div>
